if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        
        // S'assurer que les boutons du slider fonctionnent correctement sur tous les appareils
        const sliderButtons = this.elements.viewer.querySelectorAll('.slider-buttons button');
        if (sliderButtons.length) {
          sliderButtons.forEach(button => {
            button.addEventListener('click', this.handleSliderButtonClick.bind(this));
          });
        }
        
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      // Nouvelle méthode pour gérer les clics sur les boutons du slider
      handleSliderButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const direction = button.name === 'next' ? 'next' : 'previous';
        const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        const activeSlide = slider.querySelector('.is-active');
        
        if (!activeSlide) return;
        
        let targetSlide;
        if (direction === 'next') {
          targetSlide = activeSlide.nextElementSibling;
          if (!targetSlide || !targetSlide.hasAttribute('data-media-id')) {
            // Revenir au premier slide si on est sur le dernier
            targetSlide = slider.querySelector('[data-media-id]');
          }
        } else {
          targetSlide = activeSlide.previousElementSibling;
          if (!targetSlide || !targetSlide.hasAttribute('data-media-id')) {
            // Aller au dernier slide si on est sur le premier
            const allSlides = slider.querySelectorAll('[data-media-id]');
            targetSlide = allSlides[allSlides.length - 1];
          }
        }
        
        if (targetSlide && targetSlide.dataset.mediaId) {
          this.setActiveMedia(targetSlide.dataset.mediaId, false);
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        // Mettre à jour le compteur de slide
        this.updateSlideCounter(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // Nouvelle méthode pour mettre à jour le compteur de slide
      updateSlideCounter(activeMedia) {
        const counter = this.elements.viewer.querySelector('.slider-counter--current');
        if (!counter) return;
        
        const allSlides = this.elements.viewer.querySelectorAll('[data-media-id]');
        const currentIndex = Array.from(allSlides).findIndex(slide => slide === activeMedia);
        
        if (currentIndex !== -1) {
          counter.textContent = currentIndex + 1;
          
          // Gérer l'état disabled des boutons
          const prevButton = this.elements.viewer.querySelector('.slider-button--prev');
          const nextButton = this.elements.viewer.querySelector('.slider-button--next');
          
          if (prevButton) prevButton.disabled = false;
          if (nextButton) nextButton.disabled = false;
          
          if (currentIndex === 0 && prevButton) prevButton.disabled = true;
          if (currentIndex === allSlides.length - 1 && nextButton) nextButton.disabled = true;
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}